import { EventImpl } from '@fullcalendar/core/internal';
import { Box, Stack, Typography } from '@mui/material';
import i18n from 'app-i18n';
import { DateTime } from 'luxon';

const preparationTimeEvent = ({ event }: { event: EventImpl }) => {
  const startDateTime = DateTime.fromJSDate(event.start);
  const endDateTime = DateTime.fromJSDate(event.end);

  const startTimeLabel = startDateTime.toFormat('h:mm a');
  const endTimeLabel = endDateTime.toFormat('h:mm a');

  const durationMinutes = endDateTime.diff(startDateTime, 'minutes').minutes;
  const nextTimeSlotHasEvent =
    event.extendedProps?.nextTimeSlotHasEvent ?? false;

  return (
    <Stack data-testid={`PreparationTimeEvent.${event.id}`} overflow="hidden">
      {durationMinutes <= 30 || nextTimeSlotHasEvent ? (
        <Box ml={0.5}>
          <Typography noWrap fontWeight="bold">
            {`${event.title}, ${startTimeLabel}`}
          </Typography>
        </Box>
      ) : (
        <>
          <Box ml={0.5}>
            <Typography noWrap fontWeight="bold">
              {event.title}
            </Typography>
          </Box>
          {!event.allDay && !nextTimeSlotHasEvent && endDateTime.isValid && (
            <Stack ml={0.5} spacing={3}>
              <Typography noWrap>
                {`${startTimeLabel} - ${endTimeLabel}`}
              </Typography>
              {event.extendedProps.throttleSettings?.map(
                (throttleSetting: any, index: number) => (
                  <Box key={index}>
                    <Typography noWrap>
                      {i18n.t(
                        'KitchenCapacity.preparationTime.calendar.event.valueConditionLabels.orderAmount',
                        { orderAmount: throttleSetting.orderAmount },
                      )}
                    </Typography>
                    <Typography noWrap>
                      {i18n.t(
                        'KitchenCapacity.preparationTime.calendar.event.valueConditionLabels.processingTime',
                        { count: throttleSetting.processingTime },
                      )}
                    </Typography>
                  </Box>
                ),
              )}
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
};

export default preparationTimeEvent;
